import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const gigId = searchParams.get('gigId');
  const pkg = searchParams.get('package');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 font-['Poppins']">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full mx-4 text-center">
        <XCircle size={56} className="text-orange-400 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Payment Cancelled</h2>
        <p className="text-gray-500 text-sm mb-6">
          You cancelled the payment. No charges were made.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {gigId && pkg && (
            <Link
              to={`/payment/${gigId}/${pkg}`}
              className="bg-[#174568] text-white px-6 py-2.5 rounded-lg font-medium hover:bg-[#10304a] transition-colors"
            >
              Try Again
            </Link>
          )}
          <Link
            to="/category/all-services"
            className="border border-gray-300 text-gray-600 px-6 py-2.5 rounded-lg font-medium hover:bg-gray-50 transition-colors"
          >
            Browse Services
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
